/*
Will replace stage host
for immonet https://www.preview.immonet.de/ => https://www.immonet.de/
and for immowelt https://preview.immowelt.de/ => https://www.immowelt.de/
*/
const replaceHost = (path) => path
    .replace('.preview.', '.')
    .replace('.dev.', '.')
    .replace('https://dev', 'https://www')
    .replace('https://preview', 'https://www');
export const fetchSeoProps = async (seoPath, language, bffUri) => {
    // tmp - hard set seo links hosts to live (issues in SEO API)
    const replaced = replaceHost(seoPath);
    const handleException = (exception) => {
        throw exception;
    };
    const response = await fetch([bffUri, 'seo/resolve'].join(''), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify({
            locale: language,
            url: replaced,
        }),
        signal: AbortSignal.timeout(5000),
    }).catch(handleException);
    if (response.status >= 200 && response.status < 500) {
        const { criteria, paging, detail, status = 200 } = (await response.json());
        if (status === 410) {
            return { gone: true };
        }
        if (status === 301 && detail) {
            return { permanentRedirect: detail };
        }
        if (criteria && paging) {
            return {
                seoModel: criteria,
                ...paging,
            };
        }
    }
    // Should not happen as should be handled by the catch
    return {};
};
